import React, {Component} from 'react'
import {getStateAwareUrl} from 'utils/utils'

class TrailLinks extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const elem = this.props.trails?.length > 0 ? 
            this.props.trails.map(({ label, link }) => `${label}_${link}`)
            : null
    }

    render() {
        return this.props.trails?.length > 0 ? (
            <div>
                {this.props.trails.map(({label, link}, idx, arrayRef) => (
                    <>
                        <a
                            key={`trail_${label}_${link}_${idx}`}
                            href={getStateAwareUrl(link)}
                            style={{color: '#812093', opacity: link === '' ? 0.5 : 1}}
                            disabled={idx === arrayRef.length - 1}>
                            {label}
                        </a> 
                        {idx !== arrayRef.length - 1 ? (<span>&nbsp;&gt;&nbsp;</span>) : ''}  
                    </>
                ))}
            </div>
        ) : (<></>)
    }
}

export default TrailLinks